/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as React from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import moment from 'moment';
import { GlobalState } from '../../actions';
import { connect } from 'react-redux';
import { refreshSongMainAlbumId } from './actions';
import { Dispatch } from 'redux';

interface PlaylistMaintenanceProps {
    loading?: boolean;

    onRefreshSongMainAlbumId: (d: Date) => void;
}

interface PlaylistMaintenanceState {
    dateStr: string;
}

class PlaylistMaintenance extends React.Component<PlaylistMaintenanceProps, PlaylistMaintenanceState> {

    constructor(props: PlaylistMaintenanceProps) {
        super(props);

        this.state = {
            dateStr: ''
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleRefreshSongMainAlbumId = this.handleRefreshSongMainAlbumId.bind(this);
    }

    public componentDidMount(): void {
        this.setState(Object.assign({}, this.state, {dateStr: moment().format('YYYY-MM-DD')}));
    }

    public handleDateChange(e: React.FormEvent<HTMLInputElement>) {
        this.setState(Object.assign({}, this.state, {[e.currentTarget.name]: e.currentTarget.value}));
    }

    public handleRefreshSongMainAlbumId() {
        const date = moment(this.state.dateStr);
        if (date.isValid()) {
            this.props.onRefreshSongMainAlbumId(date.toDate());
        }
    }

    public render() {
        return (
            <div>
                <h4>Standard Song-Album aktualisieren für einen Tag {this.state.dateStr}</h4>
                <Form>
                    <FormGroup>
                        <Label for="dateField">Datum</Label>
                        <Input
                            type="date"
                            name="dateStr"
                            id="dateField"
                            value={this.state.dateStr}
                            onChange={this.handleDateChange}
                            disabled={false}
                        />
                    </FormGroup>
                    <Button
                        className="btn-success"
                        disabled={this.props.loading}
                        onClick={this.handleRefreshSongMainAlbumId}
                    >
                        Song-Album aktualisieren
                    </Button>

                </Form>
                <hr/>

            </div>
        );
    }
}

const mapStateToProps = (state: GlobalState) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        onRefreshSongMainAlbumId: (d: Date) => {
            dispatch(refreshSongMainAlbumId(d));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps) (PlaylistMaintenance);